import { useState } from "react";
import { Form, Input, Button, notification } from "antd";

export default function ResetForm(props) {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const onFinish = async (values) => {
    setLoading(true);

    const url = new URL('/api/auth/forgot-password', window.location);
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({
        email: values.email,
        type: 'admin',
      }),
    });

    if (res.ok) {
      props.setCurrentPageAction({
        name: "COMFIRM_PAGE",
        mail: values.email,
      });
    } else {
      notification["error"]({
        message: "Something went wrong !",
        description: `Please re-login or contact web admin. (Code: ${await res.json().then(data => data.message)})`,
      });
    }

    setLoading(false);
  };

  return (
    <>
      <div className="grid justify-center">
        <div className="text-6xl mt-6  ">Forgot Password?</div>
        <div className="text-2xl text-gray-500 mt-2 mb-10">
          Enter your email to sent your password
        </div>
        <Form
          form={form}
          className="w-102"
          layout="vertical"
          onFinish={onFinish}
          requiredMark={"optional"}
        >
          <Form.Item
            name="email"
            label={<span className="text-xl font-medium">Email</span>}
            rules={[
              {
                required: true,
                message:
                  "Please use a valid of the format example: abc@gmail.com",
              },
            ]}
            className="mb-16"
          >
            <Input
              className="rounded-lg"
              size="large"
              placeholder="Exp: abc@gmail.com"
            />
          </Form.Item>
          <Form.Item className="flex float-right">
            <Button
              className="w-52 flex items-center justify-center"
              size="large"
              shape="round"
              loading={loading}
              type="primary"
              htmlType="submit"
            >
              Submit
            </Button>
          </Form.Item>
        </Form>
      </div>
    </>
  );
}
